import { render, staticRenderFns } from "./UnitNotes.vue?vue&type=template&id=f9ca44a8&scoped=true"
import script from "./UnitNotes.vue?vue&type=script&lang=js"
export * from "./UnitNotes.vue?vue&type=script&lang=js"
import style0 from "./UnitNotes.vue?vue&type=style&index=0&id=f9ca44a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ca44a8",
  null
  
)

export default component.exports